import { render, staticRenderFns } from "./WaiterShell.vue?vue&type=template&id=4ca7c0f1&"
import script from "./WaiterShell.vue?vue&type=script&lang=ts&"
export * from "./WaiterShell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports